export default __webpack_public_path__ + "static/media/yellowArrowUp.bb7c970e.svg";